module.exports = __webpack_public_path__ + "img/metamanageselect.66295985.svg";